module.exports = __webpack_public_path__ + "img/comment-send.f822d310.svg";